module.exports = __webpack_public_path__ + "img/secondary_bg3.4ecc8693.png";